import { render } from "./PcChangeShopModal.vue?vue&type=template&id=1ff86765&scoped=true"
import script from "./PcChangeShopModal.vue?vue&type=script&lang=js"
export * from "./PcChangeShopModal.vue?vue&type=script&lang=js"

import "./PcChangeShopModal.vue?vue&type=style&index=0&id=1ff86765&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff86765"]])

export default __exports__